<pba-template-auth *ngIf="partner$ | async as partner">
  <form [formGroup]="resetPassForm" (submit)="reset()" class="w-full" novalidate>
    <div class="frame-content flex flex-col gap-4">
      <div class="title text-center">Reset password</div>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput autocomplete="new-password" type="email" placeholder="Email" formControlName="email" required />
        <mat-error *ngIf="email.invalid">{{ getErrorEmail() }}</mat-error>
      </mat-form-field>
      <button
        mat-raised-button
        [loading]="indicator"
        [disabled]="resetPassForm.invalid || indicator"
        [style.backgroundColor]="resetPassForm.valid && !indicator ? partner.loginButtonBackground : ''"
        type="submit"
        color="primary"
      >
        Reset
      </button>
      <div class="text-center">Remember your password? <a routerLink="/auth/login">Sign in</a></div>
    </div>
  </form>
</pba-template-auth>
